import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// from web-registry: src/pages/Onboard/landing/RegistryLoaderLanding/RegistryLoaderLanding.jsx
const EMOJI_LIST = [
  '💖',
  '🎶',
  // '🤵',
  // '👰',
  '💍',
  // '💃',
  // '🍾',
  // '🕺',
  '🎉',
  '🍰',
  // '✌️',
  // '🎊', // some other possible emojis
  '🥂',
  // '🍽',
];

class EmojiLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      intervalID: null,
    };
    this.updateEmoji = this.updateEmoji.bind(this);
  }

  componentDidMount() {
    const { interval } = this.props;
    const delay = interval || 300;
    this.setState({
      intervalID: setInterval(() => this.updateEmoji(), delay),
    });
  }

  componentWillUnmount() {
    const { intervalID } = this.state;
    clearInterval(intervalID);
  }

  updateEmoji() {
    const { emojis, infinite } = this.props;
    const { currentIndex } = this.state;
    const emojiList = emojis || EMOJI_LIST;
    const lastIndex = emojiList.length - 1;
    if (currentIndex === lastIndex) {
      // TODO: keep track of loop count if we decide to do so
      if (infinite) this.setState({ currentIndex: 0 });
    } else {
      this.setState({ currentIndex: currentIndex + 1 });
    }
  }

  render() {
    const { className, emojis } = this.props;
    const { currentIndex } = this.state;
    const emojiList = emojis || EMOJI_LIST;
    const loaderClass = cx('emoji-loader', className);
    return <span className={loaderClass}>{emojiList[currentIndex]}</span>;
  }
}

EmojiLoader.propTypes = {
  className: PropTypes.string,
  emojis: PropTypes.arrayOf(PropTypes.string),
  interval: PropTypes.number,
  infinite: PropTypes.bool,
};

export default EmojiLoader;



// WEBPACK FOOTER //
// ./src/components/common/zolaUI/EmojiLoader.jsx